// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

import { StoneColorTranslationFragmentDoc } from './StoneColorTranslation.fragment.generated';
export const StoneColorFragmentDoc = `
    fragment stoneColor on StoneColor {
  systemCode
  translation(locale: $locale) {
    ...stoneColorTranslation
  }
}
    `;